/**
 * Shown in place of Hub's user-management UI under studio_sso (task_2500b PR 3).
 * Studio is the canonical surface for user CRUD once identity is owned there.
 */

import { STUDIO_URL } from "@/config/studio";

export function StudioManagedUsersBanner() {
  return (
    <div className="max-w-2xl mx-auto mt-8">
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          User management has moved to Studio
        </h2>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          User accounts are now managed in GraymatterLab Studio. Create, edit,
          and deactivate users from the Studio admin console.
        </p>
        <a
          href={`${STUDIO_URL}/admin/users`}
          className="inline-flex items-center mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
        >
          Open Studio user management
        </a>
      </div>
    </div>
  );
}
